<template>

  <div class="bg-container page">
    <img class="bg-img" v-if="this.$store.getters.getBaseInfo.login_bg !==undefined" :src="this.$store.getters.getBaseInfo.login_bg !==undefined ?this.$store.getters.getBaseInfo.login_bg:''">

    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <img @click="$router.push('/')" src="img/home.png" style="width: 30px; ">
          </template>
          <template #right>
            <img @click="service" style="width: 30px; " src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABXJJREFUaEPVmb2yDUEUhZdcFV7AzxMgUSVCgBClxHgCPIBCkeMF/IQkSAkQCxCQ4gnwAIr6bs06tc8+09M9c2YCXXXr3nvOme691l577e4+u/Sfj10LxH9E0p5u3pOSvnc/vPR+7vXmALBX0jlJBHteEv8PjXeSXkp6FYBNxrUNAAK9Jul6Q9ClAJ9Ieijp01QEUwFckXR/IPDPkn6loE4MBPlA0p2eZ6q4xgKA9cedVOLkvyXBpuVRWpj6QGoQcDh9iFq5MDYbYwAQ/FtJBOFB4LDHT2a8xh5AbkuKmWEOQEBE02gF0Bc8RQiTfYEflHQgAS3pnBpCjnFc7TJaBdEK4GNi/kbHuhcA4OVOHjBbciJAwC6Fi2Q8yCqv234h5VSLnFoAIA/cxiOyQ6Cwl+2zr4hjf2AuAqZwLZcMArCAGJRmDQBsonsPFkS3DEDxt9l+2vk7Hl8aBAlYpGeJUfxklEAzCDKFxIqjBuCbJPTMoIsCiIETEQSDwFlkbBHzDAQgG9gms/zONXFoqOENAcjseyLXAw4Em82O0UMj2SNjOFHUPXPanSDIZG1MMQQA6ZhxT2Lm0TjBx0IcynTtPWSECQACopBSlG4xCyUAyAb5eDABLNySBPO8P1YyGQRBModJMAhkdLTLrLOQXW81VwkAwcK2tY8ukQ6DySfvXbqsMjckIBWcxoN56dAuasdgUM0SQpfsMBlMhpT4P7pQTRal93+mPhHZJSsQ5XowaczlrQpyLmaACfB1a58P0tpfzCQdGwOO5qwSLFnNUoKsaLcOGnKJaWdECZFSEOMM6JyBxbEAr83Bvi3Sc7lJRqdx/XldYrELYbtIbNVMI4A8GROhPbf3QT9u0BMkQBDzuo54DeZZI84fbTQSh/OhhhXgCMAPUVT2dhDbeWonrSEMSJOC5HdsiDzjNWIWbCLZ8aIEd2ReA+B0svMEfcsgSNLMsyzC/wZP/+C1aMExC/uCZMkMqvDWhbVHA3D1IyUmy8PB8tuHlT6QBI6L9M3hNWhk0ZEcfAQ7CQBMwlL0frKBW3mfFINGIrDH5719rmVuI7Au43ljOAuA2OR+dHsZB7tNg/ubnJHgkU+ccxIAUm8JudGwVrG91+guvG8TsUPR8Hzq8yOjAeQidoeeoydkHLZxmhQSdBeO9joagC2OQsIhSPNcm7kMwGtBDgP7ZkSyLN+VK0Yb9QRIhk4XOzMT8Rpenn18omI2HosA2HfF2w+yYxljKL2dOHderwDjdEoaDVa3NACvg0EAyjtSx7N2wMnbaVDzEAz4sgr0nA3QpW2zdhSdkhVnwM/aJFiT2qM5btReayA+bHhyCm3o8L4tgFxn3oJvnEVaAeQT2uA5tRL9bkn7JX1Nn4sbuGjRdh4ktdE4WwGwVmxgPruOPVaelnRX0k1JbxIAs5xrzGfzXuseAyDuWbK9ORZ0TJBfOtcwy8ck8XOxC/5eCj7uPqlDH27izYg3emuPjgWAhVEPPm72nY8vSXpekNEHSccl/Qnv+5xAgATsrUO8jy1ecI0F4HXjDULf9d/ZLtAz3e9nkh5Jet0DjAOKbz3ivide4eQt+GqaqQCYgB0pQAiAxjJlECSOg/RiPcWbv8FbkG0AEDBp5pwLc1NsFb1H1n1Z7DNw9Zp9WwBTWC89g0x8X0RWYj0U11kKgL8AZGEcZe0uJ0VDoGzcfJXD6Y0MNJ0tlgCQN4G231gn8WtZNyd/XRXPwNUMLwHADgXrdFf2UmwG+Tse8B0cHdbn5bGNce1Wooq28QP5ZJW/4WEaZOJvNLe5nl8EQOwRBOdvWPwV6lxX8jt8LiEhCpjA4/fAVTtszO7Gx5YA4EV8qUV/mJX1iGJJAFNJHfXcP/mqiEDZsEJxAAAAAElFTkSuQmCC">
          </template>
        </van-nav-bar>
        <div class="wrapper" style="margin-top: 50px;background: linear-gradient(hsla(0, 0%, 100%, 0), #7e5678);height: 100vh;">
          <div class="loginForm">
            <div class="label" v-if="false">{{ $t("账户") }}</div>
            <van-field v-model="username"  clearable  class="input"  :placeholder="$t('register.username')" />
            <div class="label" v-if="false" style="margin-top: 10px">{{ $t("密码") }}</div>
            <van-field style="margin-top: 10px"
                v-model="password"
                :type="passwordType"
                class="input"
                :placeholder="$t('register.password')">
              <template slot="right-icon">
                <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
              </template>
            </van-field>

            <div class="label" v-if="false" style="margin-top: 10px">{{ $t("验证密码") }}</div>
            <van-field v-if="false"
                v-model="password1"
                :type="passwordType1"
                class="input"
                :placeholder="$t('请重新输入密码')">
              <template slot="right-icon">
                <van-icon :name=" passwordType1 === 'password' ? 'closed-eye':'eye-o'" @click="passwordType1 = passwordType1 === 'password' ? 'text' : 'password' "/>
              </template>
            </van-field>

            <div class="label" v-if="false" style="margin-top: 10px">{{ $t("二级密码") }}</div>
            <van-field v-if="false"
                v-model="paypass"
                :type="passwordType2"
                class="input"
                :placeholder="$t('请输入付款密码')">
              <template slot="right-icon">
                <van-icon :name=" passwordType2 === 'password' ? 'closed-eye':'eye-o'" @click="passwordType2 = passwordType2 === 'password' ? 'text' : 'password' "/>
              </template>
            </van-field>

            <div class="label" v-if="false" style="margin-top: 10px">{{ $t("二级密码验证") }}</div>
            <van-field v-if="false"
                v-model="paypass1"
                :type="passwordType3"
                class="input"
                :placeholder="$t('请输入付款密码')">
              <template slot="right-icon">
                <van-icon :name=" passwordType3 === 'password' ? 'closed-eye':'eye-o'" @click="passwordType3 = passwordType3 === 'password' ? 'text' : 'password' "/>
              </template>
            </van-field>

            <div class="label" v-if="false" style="margin-top: 10px">{{ $t("邀请码") }}</div>
            <van-field v-model="code" style="margin-top: 10px" clearable  class="input"  :placeholder="$t('register.code')" />

            <div class="agreement" v-if="false">
              <van-checkbox v-model="checked" />
              <span class="agreement-text">{{ $t("register.agreement") }}</span>
            </div>
            <van-button class="register-btn"   type="primary" size="normal" @click="doRegister()">{{ $t("register.doRegister") }}</van-button>
            <div @click="toLogin()" class="register-text">
              <span> {{ " "+$t("返回登录") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      password: this.inputValue,
      password1: "",
      paypass: "",
      paypass1: "",
      passwordType: 'password',
      passwordType1: 'password',
      passwordType2: 'password',
      passwordType3: 'password',
    };
  },
  methods: {

    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    filterSpaces(event) {
      this.username = event.replace(/[^a-zA-Z0-9]/g, '');
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    toLogin(){
      this.$router.push("Login")
    },
    doRegister() {


      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast(this.$t('login.username')+"!");
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast(this.$t('login.password')+"!");
        return false;
      }
      /*if(this.password1 === "" || this.password1 === null || this.password1 === undefined){
        this.$toast(this.$t('请重新输入密码')+"!");
        return false;
      }*/
      /*if(this.paypass === "" || this.paypass === null || this.paypass === undefined){
        this.$toast(this.$t('请输入付款密码')+"!");
        return false;
      }
      if(this.paypass1 === "" || this.paypass1 === null || this.paypass1 === undefined){
        this.$toast(this.$t('请输入付款密码')+"!");
        return false;
      }*/
     /* if(this.password1 != this.password){
        this.$toast(this.$t('重新输入密码不正确')+"!");
        return false;
      }*/

      /*if(this.paypass != this.paypass1){
        this.$toast(this.$t('二级密码不一致')+"!");
        return false;
      }*/

      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast(this.$t('register.code')+"!");
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t('register.chooseAgreement'));
        return false;
      }
      this.$http({
        method: 'get',
        data:{
          username:this.username,
          password:this.password,
          paypass: this.paypass,
          code:this.code
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(this.$t("msg."+res.msg));
            localStorage.setItem('token',res.data)
            this.$router.push("Mine")
          }else {
            this.$toast.fail(this.$t("msg."+res.msg));
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.register{
  height: 100%;
}

.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container{
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper .logo-img{
  width: 100%;
  margin: 2rem 0 1rem 0;
}
.register .wrapper .title{
  font-size: 45px;
  font-weight: 700;
  color: #000;
  margin-top: 10px;
  line-height: 60px;
}
.register .wrapper .title1{
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
  color: #848fac;
  margin-top: 10px;
}
.label{
  color: #2a3563;
  font-weight: 600;
}
.register .wrapper .loginForm .input{
  padding: 10px 20px;
  border: 1px solid #dfe8f6;
  line-height: 70px;
  font-size: 30px;
  color: #4e4e4e;
  border-radius: 20px;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 40px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.register .wrapper .loginForm .reset-text{
  margin: 30px 15px;
  text-align: center;
  font-size: 28px;
}
.register .wrapper .loginForm .reset-text span{
  color: #333;
  font-weight: 500;
}
.register .wrapper .loginForm .register-text{
  margin: 30px 0;
  text-align: center;
}
.register .wrapper .loginForm .register-text span{
  font-size: 32px;
  font-weight: 600;
}
.register .wrapper .loginForm .register-btn{
  margin-top: 50px;
  width: 100%;
  height: 100px;
  border-radius: 15px;
  color: #fff;
  background: linear-gradient(90deg, #e62978, #cc2996);;
  font-size: 34px;
  font-weight: bolder;
  border: none;
}
</style>
